class PdpVideoTestimonial extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-video-trigger]');
    this.modal = this.querySelector('[data-video-modal]');
    this.closeBtn = this.querySelector('[data-video-modal-close]');
    this.nativeVideo = this.querySelector('[data-native-video]');
    this.iframeVideo = this.querySelector('[data-video-iframe]');
    this.mediaCard = this.querySelector('[data-media-card]');
    this.inlineWrapper = this.querySelector('[data-inline-video-wrapper]');

    this.handleInlineEnded = this.handleInlineEnded.bind(this);
  }

  connectedCallback() {
    this.usePopup = this.getAttribute('data-use-popup') !== 'false';

    if (this.usePopup) {
      if (this.trigger && this.modal) {
        this.trigger.addEventListener('click', this.openModal.bind(this));
      }
      if (this.closeBtn && this.modal) {
        this.closeBtn.addEventListener('click', this.closeModal.bind(this));
      }
      if (this.modal) {
        // Close modal on backdrop click
        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) {
            this.closeModal();
          }
        });
        // Handle ESC key stop video
        this.modal.addEventListener('cancel', () => {
          this.stopVideo();
        });
      }
    } else {
      if (this.trigger) {
        this.trigger.addEventListener('click', this.playInline.bind(this));
      }
      if (this.nativeVideo) {
        this.nativeVideo.addEventListener('ended', this.handleInlineEnded);
      }

      // PostMessage listeners for YouTube & Vimeo iframe states
      this.messageHandler = (event) => {
        if (typeof event.data === 'string') {
          try {
            // YouTube Pause/End States
            if (event.data.includes('infoDelivery')) {
              const data = JSON.parse(event.data);
              if (data.event === 'infoDelivery' && data.info) {
                if (data.info.playerState === 2 || data.info.playerState === 0) {
                  this.handleInlineEnded();
                }
              }
            }
            // Vimeo Pause/End States
            const data = JSON.parse(event.data);
            if (data.event === 'pause' || data.event === 'finish') {
              this.handleInlineEnded();
            }
          } catch (e) {}
        }
      };
      window.addEventListener('message', this.messageHandler);
    }
  }

  disconnectedCallback() {
    if (this.messageHandler) {
      window.removeEventListener('message', this.messageHandler);
    }

    if (this.nativeVideo) {
      this.nativeVideo.removeEventListener('ended', this.handleInlineEnded);
    }
  }

  openModal() {
    this.modal.showModal();
    document.body.classList.add('overflow-hidden');
    this.playVideo();
  }

  closeModal() {
    this.modal.close();
    document.body.classList.remove('overflow-hidden');
    this.stopVideo();
  }

  playInline() {
    if (this.mediaCard) {
      this.mediaCard.classList.add('is-playing');
    }
    this.playVideo();
  }

  handleInlineEnded() {
    if (this.mediaCard) {
      this.mediaCard.classList.remove('is-playing');
    }

    if (this.nativeVideo) {
      this.nativeVideo.currentTime = 0;
    }
  }

  playVideo() {
    if (this.nativeVideo) {
      this.nativeVideo.play().catch((error) => {
        console.warn('Auto-playback failed or was blocked: ', error);
      });
    } else if (this.iframeVideo) {
      // For YouTube/Vimeo iframe autoplay support, append autoplay query params if possible
      const currentSrc = this.iframeVideo.src;
      if (currentSrc.includes('youtube.com') && !currentSrc.includes('autoplay=1')) {
        this.iframeVideo.src = currentSrc + (currentSrc.includes('?') ? '&' : '?') + 'autoplay=1';
      } else if (currentSrc.includes('player.vimeo.com') && !currentSrc.includes('autoplay=1')) {
        this.iframeVideo.src = currentSrc + (currentSrc.includes('?') ? '&' : '?') + 'autoplay=1';
      }
    }
  }

  stopVideo() {
    if (this.nativeVideo) {
      this.nativeVideo.pause();
    } else if (this.iframeVideo) {
      // Reload the iframe to stop playback completely
      const currentSrc = this.iframeVideo.src;
      this.iframeVideo.src = currentSrc.replace('&autoplay=1', '').replace('?autoplay=1', '');
    }
  }
}

if (!customElements.get('pdp-video-testimonial')) {
  customElements.define('pdp-video-testimonial', PdpVideoTestimonial);
}
